export const getLevelStyle = (level) => {
  const levelStyles = {
    INTERN: {
      color: {
        bg: 'bg-blue-600',
        bgLight: 'bg-blue-50',
        border: 'border-blue-600',
        placeholderBorder: 'border-blue-600',
      },
      text: 'INTERN',
    },
    'NEW-GRAD': {
      color: {
        bg: 'bg-red-500',
        bgLight: 'bg-red-50',
        border: 'border-red-700',
        placeholderBorder: 'border-red-500',
      },
      text: 'NEW GRAD',
    },
    'FULL-TIME': {
      color: {
        bg: 'bg-green-600',
        bgLight: 'bg-green-50',
        border: 'border-green-700',
        placeholderBorder: 'border-green-600',
      },
      text: 'FULL-TIME',
    },
    'PART-TIME': {
      color: {
        bg: 'bg-pink-600',
        bgLight: 'bg-pink-50',
        border: 'border-pink-600',
        placeholderBorder: 'border-pink-600',
      },
      text: 'PART-TIME',
    },
    CONTRACT: {
      color: {
        bg: 'bg-yellow-600',
        bgLight: 'bg-yellow-50',
        border: 'border-yellow-700',
        placeholderBorder: 'border-yellow-600',
      },
      text: 'CONTRACT',
    },
    FREELANCE: {
      color: {
        bg: 'bg-teal-600',
        bgLight: 'bg-teal-50',
        border: 'border-teal-700',
        placeholderBorder: 'border-teal-600',
      },
      text: 'FREELANCE',
    },
  };

  return levelStyles[level?.toUpperCase()] || {
    color: {
      bg: 'bg-gray-600', bgLight: 'bg-gray-50', border: 'border-gray-600', placeholderBorder: 'border-gray-600',
    },
    text: level?.toUpperCase() || '',
  };
};

export const companyLogoSrc = (domain) => `https://img.logo.dev/${domain}?token=pk_TgiZyydaQm6-3wrMV_nkuA`;

export const formatNumber = (num) => {
  const number = Number(num);

  if (number >= 1_000_000) return `${(number / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (number >= 1_000) return `${(number / 1_000).toFixed(1).replace(/\.0$/, '')}k`;

  return number.toString();
};
